module.exports = __webpack_public_path__ + "img/10-2.96b808e0.jpg";